import { PayoutRecipient } from '@common/enums';
import { getDisplayName } from '@common/utils/getDisplayName';
import { never } from '@common/utils/never';
import type { PayoutRecord } from '../../adminProcessDetailsTypes';

export function getPayoutRecipientName(payoutRecord: PayoutRecord) {
    let payoutRecipientName = null;

    switch (payoutRecord.entityToPay) {
        case PayoutRecipient.practitioner: {
            const practitionerFormattedName = formatPractitionerName(payoutRecord.providerName);
            payoutRecipientName = `${practitionerFormattedName} in ${payoutRecord.providerOrganizationName}`;
            break;
        }
        case PayoutRecipient.organization:
            payoutRecipientName = payoutRecord.providerOrganizationName;
            break;
        case PayoutRecipient.group:
            payoutRecipientName = payoutRecord.providerGroup;
            break;
        default:
            never(payoutRecord.entityToPay);
    }

    return payoutRecipientName;
}

function formatPractitionerName(providerName: string): string {
    const splitName = providerName.split(' ');

    if (splitName.length === 2) {
        return getDisplayName({ nameFamily: splitName[1], nameGiven: splitName[0] });
    } else if (splitName.length === 3) {
        return getDisplayName({
            nameFamily: splitName[2],
            nameGiven: splitName[0],
            nameInfix: splitName[1],
        });
    } else {
        return providerName;
    }
}
